import * as types from './actionTypes';
import { openBackdropOverlay, closeBackDropOverlay } from './apiStatusActions';
import { openErrorSnackBar } from './snackBarActions';
import { logAndReturnErrorMsg } from '../../Utils/ErrorLog';
import { manageProductDetailsRetrieveErrorMsg } from '../../Constants/ErrorMessages';
import axios from 'axios';
import { esApiKey, productEsUrl } from '../../Constants/Api';
import { productElasticSearchMatchFields } from '../../Constants/Products';
import { getAssetsFromES } from './searchActions';

export function dispatchActionData(type, data) {
	return { type: type, data: data };
}

export function setManageProductData(data) {
	return function (dispatch) {
		dispatch(dispatchActionData(types.FETCH_MANAGE_PRODUCT_DATA, data));
	};
}
// below method retrieves merged product data from pcm and bifrost from `Product` index of ES by id.
export const getProductDataFromESById = (productId) => {
	return axios
		.get(`${productEsUrl}/_doc/${productId}`, {
			headers: {
				Authorization: `ApiKey ${esApiKey}`,
			},
		})
		.then((response) => {
			return response;
		})
		.catch((error) => {
			throw error;
		});
};
// below method retrieves merged product data from pcm and bifrost from `Product` index of ES.
export const getProductMergedDataFromElasticSearch = (searchQuery, size = 100, from = 0, isBuyable) => {
	const must = [];
	if (isBuyable !== undefined){
		must.push({
			multi_match: {
				query: isBuyable ? 'Y' : 'N',
				fields: ['product.isBuyable'],
			},
		});
	}
	const query = {
		size: size,
		from: from,
		track_total_hits: true,
		query: {
			bool: {
				must: {
					multi_match: {
						query: `${searchQuery}`,
						operator: 'AND',
						fields: productElasticSearchMatchFields,
					},
				},
				filter: {
					bool: {
						must: must,
					},
				},
			},
		},
	};
	return axios
		.get(`${productEsUrl}/_search`, {
			headers: {
				Authorization: `ApiKey ${esApiKey}`,
			},
			params: {
				source: JSON.stringify(query),
				source_content_type: 'application/json',
			},
		})
		.then((response) => {
			return response;
		})
		.catch((error) => {
			throw error;
		});
};

// action creator for getting product data by uuid
export function fetchManageProductByUUID(data) {
	return async function (dispatch) {
		dispatch(openBackdropOverlay());
		try {
			const response = await getProductDataFromESById(data);
			const rootObj = response?.data;
			const id = rootObj?._id;
			rootObj._source.product.id = id;
			const productDetails = { ...rootObj._source };
			// get the linked asset for a product by UUID.
			const asset = await getAssetsFromES(id);
			if (asset.length > 0) {
				productDetails['linkedAsset'] = asset[0];
			}
			if (productDetails) {
				dispatch(setManageProductData(productDetails));
			}
		} catch (error) {
			dispatch(openErrorSnackBar(logAndReturnErrorMsg(error, manageProductDetailsRetrieveErrorMsg)));
		} finally {
			dispatch(closeBackDropOverlay());
		}
	};
}
